module.exports = __webpack_public_path__ + "img/calls-receive.6bf24f52.svg";